"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineAvailability = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const OnlineAvailability = ({ hdExcluded, ccExcluded, storeSourceExcluded, fulfillmentCopyDescription, }) => !(ccExcluded && !hdExcluded && !storeSourceExcluded && !!fulfillmentCopyDescription) ? null : ((0, jsx_runtime_1.jsx)(cotopaxi_1.Box, { mobile: { spacing: { marginTop: 3 } }, dataAttributes: { 'data-qa': 'check_stock_title' }, children: (0, jsx_runtime_1.jsx)(cotopaxi_1.Text, { inline: true, children: fulfillmentCopyDescription }) }));
exports.OnlineAvailability = OnlineAvailability;
